import { StyleData } from '@gsc/types'
import { resolveColorVariables } from './colors'
import { iconArrow, iconBack, iconCheckmark, iconClose, iconCircle } from './icons'

export function getHostStyles(styleData: Partial<StyleData>): string {
  const { colors, width, maxWidth, padding = {}, overflow } = styleData
  const {
    background,
    text,
    button,
    buttonHover,
    buttonText,
    secondaryButton,
    secondaryButtonHover,
    secondaryButtonText,
    normalButton,
    normalButtonText,
    input,
    inputText,
    inputPlaceholder,
  } = resolveColorVariables(colors)
  return `
:host {
  --root-width: ${width};
  --root-max-width: ${maxWidth};
  --root-padding-left: ${padding.left};
  --root-padding-top: ${padding.top};
  --root-padding-right: ${padding.right};
  --root-padding-bottom: ${padding.bottom};
  --root-overflow: ${overflow};
  --root-bg: ${background};
  --root-color: ${text};
  --button-primary-bg: ${button};
  --button-primary-hover-bg: ${buttonHover};
  --button-primary-color: ${buttonText};
  --button-secondary-bg: ${secondaryButton};
  --button-secondary-hover-bg: ${secondaryButtonHover};
  --button-secondary-color: ${secondaryButtonText};
  --button-normal-bg: ${normalButton};
  --button-normal-color: ${normalButtonText};
  --input-bg: ${input};
  --input-color: ${inputText};
  --input-placeholder-color: ${inputPlaceholder};
  --icon-close: ${iconClose(text)};
  --icon-back: ${iconBack(text)};
  --icon-caret: ${iconArrow(text)};
  --icon-arrow: ${iconArrow(inputText)};
  --icon-checkmark: ${iconCheckmark(inputText)};
  --icon-circle: ${iconCircle(inputText)};
}
`
}
